import ui from '@bmp-vue/core/api/ui'
import api from '@bmp-vue/core/api'


export default {
    CustomPostAction: (response) => {
        ui.HideLoading()
        const tipoResponse = api.Enum.TipoResponseContextoCadastros

        if (response.tipoMensagem === tipoResponse.Alerta) {
            ui.ShowAlert(response.titulo || "Atenção", response.mensagem || '')
            return true
        }

        if (response.tipoMensagem === tipoResponse.Sucesso) {
            ui.ShowSuccess(response.titulo || "Sucesso", response.mensagem || 'Operação Realizada com Sucesso!')
            return true
        }

        ui.ShowError(response.titulo || 'Erro', response.mensagem || "Ocorreu um erro na requisição")
        return false
    },
}